import React from 'react'
import { Modal, Heading, Card } from '@enterprise-ui/canvas-ui-react'
import { ActiveAnnouncement } from '../../services/notifications'
import EnterpriseIcon, { InfoIcon } from '@enterprise-ui/icons'

interface AnnouncementModalProps {
  announcements: ActiveAnnouncement[]
  isOpen: boolean
  onClose: () => void
}

const getMessageTypeColorClass = (messageType: string) => {
  switch (messageType.toUpperCase()) {
    case 'MAINTENANCE':
      return 'hc-clr-alert'
    case 'URGENT':
      return 'hc-clr-error'
    case 'INFO':
      return 'hc-clr-interactive'
    default:
      return 'hc-clr-interactive'
  }
}

// Helper function to get CSS border color classes
const getMessageTypeBorderColorClass = (messageType: string) => {
  switch (messageType.toUpperCase()) {
    case 'MAINTENANCE':
      return 'hc-border-alert'
    case 'URGENT':
      return 'hc-border-error'
    case 'INFO':
      return 'hc-border-interactive'
    default:
      return 'hc-border-interactive'
  }
}

export const AnnouncementModal: React.FC<AnnouncementModalProps> = ({
  announcements,
  isOpen,
  onClose,
}) => {
  if (!isOpen) return null

  return (
    <Modal
      isVisible={isOpen}
      onRefuse={onClose}
      aria-label="Active Announcements"
      size="normal"
    >
      <div className="hc-pa-none">
        {/* Stylish Header */}
        <div
          className="hc-pa-lg hc-d-flex hc-justify-space-between hc-align-center"
          style={{
            borderRadius: '8px 8px 0 0',
          }}
        >
          <Heading
            size={4}
            className="hc-clr-error"
            style={{
              margin: 0,
              opacity: 0.9,
              filter: 'saturate(1.2) brightness(1.1) contrast(1)',
            }}
          >
            Active Announcements
          </Heading>
        </div>

        {/* Content Area */}
        <div className="hc-ph-lg hc-bg-white">
          {announcements.length > 0 ? (
            <div className="hc-d-flex hc-flex-column hc-gap-normal">
              {announcements.map((announcement) => (
                <Card
                  key={announcement.id}
                  elevation={2}
                  className={`hc-pa-lg hc-w-100 hc-mb-normal hc-border-width-lg hc-border-solid hc-border-radius-lg ${getMessageTypeBorderColorClass(announcement.message_type)}`}
                >
                  {/* Announcement Header */}
                  <div className="hc-mb-normal">
                    <div className="hc-d-flex hc-align-center hc-mb-xs">
                      <Heading
                        size={5}
                        className={getMessageTypeColorClass(
                          announcement.message_type,
                        )}
                        style={{
                          margin: 0,
                        }}
                      >
                        {announcement.title}
                      </Heading>
                    </div>
                  </div>

                  {/* Announcement Content */}
                  <div
                    className="hc-fs-normal hc-lh-relaxed"
                    style={{
                      padding: '16px',
                      backgroundColor: '#f8f9fa',
                      borderRadius: '6px',
                      border: '1px solid #e9ecef',
                    }}
                    dangerouslySetInnerHTML={{
                      __html: announcement.content,
                    }}
                  />
                </Card>
              ))}
            </div>
          ) : (
            <div className="hc-ta-center hc-pa-4x">
              <EnterpriseIcon
                icon={InfoIcon}
                size="xl"
                className="hc-clr-subtle hc-mb-normal"
              />
              <Heading size={5} className="hc-clr-subtle hc-mb-xs">
                No Active Announcements
              </Heading>
              <p className="hc-clr-subtle">
                There are no active announcements for your current view.
              </p>
            </div>
          )}
        </div>
      </div>
    </Modal>
  )
}
